// extracted by mini-css-extract-plugin
export default {"Settings":"Settings_Settings__SSg60","Head":"Settings_Head__WbJ9G","Title":"Settings_Title__FPO6V","Btn":"Settings_Btn__g5ReQ"};